import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  AdminSetOrganizationConfigError,
  AdminLoadCurrentOrganizationConfig,
  AdminSetCurrentOrganizationConfig,
  AdminCreateOrganizationConfig,
  AdminDeleteOrganizationConfig,
} from './admin-organization-config.actions';
import { AdminOrganizationConfigService } from './admin-organization-config.service';
import { AdminOrganizationConfig } from 'src/app/admin/models/organization.model';

@Injectable()
export class AdminOrganizationConfigEffects {
  getOrganization$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminLoadCurrentOrganizationConfig),
      mergeMap(({ id }) =>
        this.organizationConfigService.getOrganizationConfig(id).pipe(
          map((config: AdminOrganizationConfig) => AdminSetCurrentOrganizationConfig({ config })),
          catchError((error) => of(AdminSetOrganizationConfigError({ error }))),
        ),
      ),
    ),
  );

  addOrganization$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminCreateOrganizationConfig),
      mergeMap(({ organizationId, config }) =>
        this.organizationConfigService.addOrganizationConfig(organizationId, config).pipe(
          map((organizationConfig: AdminOrganizationConfig) =>
            AdminSetCurrentOrganizationConfig({ config: organizationConfig }),
          ),
          catchError((error) => of(AdminSetOrganizationConfigError({ error }))),
        ),
      ),
    ),
  );

  deleteOrganizationConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminDeleteOrganizationConfig),
      mergeMap(({ id }) =>
        this.organizationConfigService.deleteOrganizationConfig(id).pipe(
          map(() => AdminSetCurrentOrganizationConfig({ config: null })),
          catchError((error) => of(AdminSetOrganizationConfigError({ error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private organizationConfigService: AdminOrganizationConfigService,
  ) {}
}
